module.exports = __webpack_public_path__ + "img/lottecom.cea5979b.png";